import leftCrystal from 'assets/games/theme-cash-stream/slot/left.png';
import rightCrystal from 'assets/games/theme-cash-stream/slot/right.png';

import styles from './graphic.module.css';

function SlotMachineGraphic() {
    return (
        <div className={styles.SlotMachineGraphic}>

            <img src={leftCrystal} alt="leftCrystal" className={styles.leftCrystal}/>

            <img
                src={rightCrystal}
                alt="rightCrystal"
                className={styles.rightCrystal}
            />

        </div>
    );
}

export {SlotMachineGraphic};
